export enum ScheduledMissionType {
	Future = 1,
	Past = 2,
	Present = 3,
}
